import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const pagingBLock = (params) => get('/api/v1/block/paging',params)
export const detailBLock=(query)=>getOne(`/api/v1/block/detail/${query}`)
export const updateBLock=(body)=>put(`/api/v1/block/update`,body)
export const createBLock=(body)=>post(`/api/v1/block/create`,body)
export const deleteBLock = (body) => destroy(`/api/v1/block/delete`,body)